import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTruck } from "react-icons/fa";
import CourierCompaniesList from './CourierCompaniesList';
import CargoCompaniesList from './CargoCompaniesList';



const Navbar = () => {
  const location = useLocation();
  const [trackingNumber, setTrackingNumber] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Tracking ${trackingNumber}`);
  };

  return (
    <>
    <nav className="navbar navbar-expand-lg navbar-dark fixed-tops">
     
      <div className="container">
      
        <Link className="navbar-brand fw-bold fs-3" to="/">
          <FaTruck className="me-2" /> Combine
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-9">
                    <input
                      type="text"
                      className="form-control form-large fs-5"
                      placeholder="Enter Tracking Number"
                      value={trackingNumber}
                      onChange={(e) => setTrackingNumber(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <button className="btn btn-primary w-100s h-100 fs-5">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </li>
          </ul>

          <div className="d-flex">
          <CourierCompaniesList />
          <CargoCompaniesList />
          </div>
        </div>
      </div>
    </nav>
    </>
  );
};

export default Navbar;